// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.newsPage {
  max-width: 1180px;
  margin: 24px 0;
  color: #334155;
}
.newsPage__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 18px;
}
.newsPage__header h1 {
  margin: 0;
  color: #142033;
  font-size: 24px;
  font-weight: 800;
}
.newsPage__header p {
  margin: 4px 0 0;
  color: #69778a;
  font-size: 14px;
}
.newsBtn {
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  padding: 0 15px;
  border: 1px solid #cbd5e1;
  border-radius: 9px;
  background: #fff;
  color: #334155;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}
.newsBtn--primary {
  border-color: #227ebd;
  background: #227ebd;
  color: #fff;
}
.newsBtn--ghost.is-active {
  border-color: #227ebd;
  background: #eef7fd;
  color: #155d8c;
}
.newsBtn--danger {
  border-color: #c9364b;
  background: #c9364b;
  color: #fff;
}
.newsBtn--dangerGhost {
  border-color: #efb4bd;
  background: #fff5f6;
  color: #a7283b;
}
.newsPage__toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid #dbe3ec;
  border-radius: 12px;
  background: #fff;
}
.newsPage__toolbarTitle {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: auto;
}
.newsPage__toolbarTitle strong {
  color: #142033;
  font-size: 15px;
}
.newsPage__toolbarTitle span {
  padding: 2px 8px;
  border-radius: 999px;
  background: #eef2f6;
  color: #69778a;
  font-size: 11px;
  font-weight: 700;
}
.newsPage__search {
  display: flex;
  width: 290px;
  height: 40px;
  align-items: center;
  gap: 8px;
  padding: 0 11px;
  border: 1px solid #cbd5e1;
  border-radius: 9px;
}
.newsPage__search:focus-within {
  border-color: #368fca;
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.11);
}
.newsPage__search input {
  min-width: 0;
  flex: 1;
  border: 0;
  outline: 0;
  font: inherit;
  font-size: 13px;
}
.newsPage__search > svg {
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  fill: none;
  stroke: #667085;
  stroke-width: 2;
  stroke-linecap: round;
}
.newsPage__search button {
  border: 0;
  background: none;
  color: #69778a;
  font-size: 18px;
}
.newsPage__filters {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  margin-top: 10px;
  padding: 14px;
  border: 1px solid #dbe3ec;
  border-radius: 12px;
  background: #f8fafc;
}
.newsPage__filters label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
}
.newsPage__filters input {
  height: 40px;
  padding: 0 10px;
  border: 1px solid #cbd5e1;
  border-radius: 9px;
  background: #fff;
  color: #142033;
}
.newsPage__filters > div {
  display: flex;
  gap: 8px;
  margin-left: auto;
}
.newsPage__selection {
  display: flex;
  align-items: center;
  margin-top: 10px;
  padding: 10px 13px;
  border: 1px solid #b9d9ee;
  border-radius: 10px;
  background: #eef7fd;
  color: #155d8c;
  font-size: 13px;
  font-weight: 700;
}
.newsPage__selection > div {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}
.newsPage__clear {
  border: 0;
  background: none;
  color: #526174;
  font-size: 12px;
  text-decoration: underline;
}
.newsPage__tableCard {
  overflow: hidden;
  margin-top: 14px;
  border: 1px solid #dbe3ec;
  border-radius: 12px;
  background: #fff;
}
.newsPage__tableScroll {
  overflow-x: auto;
}
.newsPage__table {
  width: 100%;
  min-width: 760px;
  border-collapse: collapse;
}
.newsPage__table th {
  height: 44px;
  padding: 0 14px;
  border-bottom: 1px solid #dbe3ec;
  background: #f8fafc;
  color: #69778a;
  font-size: 11px;
  font-weight: 750;
  letter-spacing: 0.045em;
  text-align: left;
  text-transform: uppercase;
}
.newsPage__table th button {
  border: 0;
  background: none;
  color: inherit;
  font: inherit;
  letter-spacing: inherit;
  text-transform: inherit;
}
.newsPage__table td {
  height: 68px;
  padding: 8px 14px;
  border-bottom: 1px solid #e8edf2;
  font-size: 13px;
}
.newsPage__table tbody tr {
  cursor: pointer;
}
.newsPage__table tbody tr:hover,
.newsPage__table tbody tr.is-selected {
  background: #f4f9fc;
}
.newsPage__check {
  width: 46px;
  text-align: center !important;
}
.newsPage__check input {
  width: 16px;
  height: 16px;
  accent-color: #227ebd;
}
.newsPage__newsCell {
  display: flex;
  align-items: center;
  gap: 12px;
}
.newsPage__newsCell img,
.newsPage__placeholder {
  width: 48px;
  height: 42px;
  flex: 0 0 48px;
  border-radius: 8px;
  object-fit: cover;
}
.newsPage__placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e6f2fa;
  color: #227ebd;
  font-weight: 800;
}
.newsPage__newsCell div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}
.newsPage__newsCell strong {
  color: #142033;
  font-size: 13px;
}
.newsPage__newsCell small {
  max-width: 520px;
  overflow: hidden;
  color: #69778a;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.newsPage__status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 9px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 750;
}
.newsPage__status i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}
.newsPage__status.is-published {
  background: #eaf8f0;
  color: #237648;
}
.newsPage__status.is-scheduled {
  background: #eef4ff;
  color: #365f9d;
}
.newsPage__empty {
  padding: 32px 14px !important;
  color: #69778a;
  text-align: center;
}
.newsPage__pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  margin-top: 14px;
}
.newsPage__pagination > span {
  margin-right: auto;
  color: #69778a;
  font-size: 12px;
}
.newsPage__pagination button {
  min-width: 36px;
  height: 36px;
  padding: 0 10px;
  border: 1px solid #d3dce6;
  border-radius: 8px;
  background: #fff;
  color: #475569;
  font-size: 12px;
}
.newsPage__pagination button.is-active {
  border-color: #227ebd;
  background: #227ebd;
  color: #fff;
}
.newsPage__pagination button:disabled {
  opacity: 0.45;
}
.newsPage__pagination i {
  padding: 0 4px;
  color: #94a3b8;
}
.newsFormModal {
  max-width: 800px !important;
}
.newsDeleteModal {
  max-width: 480px !important;
}
.newsDelete {
  padding: 4px 2px;
}
.newsDelete__icon {
  display: flex;
  width: 44px;
  height: 44px;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
  border-radius: 50%;
  background: #fff0f2;
  color: #bd2f43;
  font-size: 22px;
  font-weight: 800;
}
.newsDelete p {
  margin: 0;
  color: #475569;
  font-size: 14px;
  line-height: 1.55;
}
.newsDelete__actions {
  display: flex;
  justify-content: flex-end;
  gap: 9px;
  margin-top: 24px;
}
@media (max-width: 760px) {
  .newsPage {
    margin: 16px;
  }
  .newsPage__header,
  .newsPage__toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .newsPage__search {
    width: auto;
  }
  .newsPage__filters {
    align-items: stretch;
    flex-direction: column;
  }
  .newsPage__filters > div {
    margin-left: 0;
  }
  .newsPage__pagination > span {
    display: none;
  }
}

/* Modern list layout shared with People and General messages. */
.newsPage {
  position: relative;
  width: 100%;
  max-width: none;
  min-height: calc(100vh - 76px);
  margin: 0 !important;
  padding: 0 0 32px;
  background: var(--surface-page, #f8fafc);
}

.newsPage__header {
  display: flex;
  width: calc(100% + 48px);
  height: 70px;
  min-height: 70px;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin: -20px 0 18px -24px;
  padding: 0 72px 0 28px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}

.newsPage__toolbar {
  min-height: 48px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 12px 12px 0 0;
  background: var(--surface-card, #fff);
  gap: 8px;
}

.newsPage__header .newsPage__title {
  flex: 0 0 auto;
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 22px;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.015em;
  white-space: nowrap;
}

.newsPage__title > span,
.newsPage__toolbar .newsBtn > b {
  display: inline-flex;
  min-width: 22px;
  height: 22px;
  align-items: center;
  justify-content: center;
  padding: 0 7px;
  border-radius: 999px;
  background: #eef2f6;
  color: #667085;
  font-size: 11px;
  font-weight: 800;
}

.newsPage__title > span {
  margin-left: 7px;
  vertical-align: middle;
}

.newsPage__toolbar .newsBtn,
.newsPage__search {
  height: 40px;
  min-height: 40px;
}

.newsPage__filterButton {
  position: relative;
  display: inline-flex;
  width: auto;
  min-width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 12px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #334155;
  cursor: pointer;
  font-size: 12.5px;
  font-weight: 700;
  white-space: nowrap;
}

.newsPage__filterButton svg {
  width: 18px;
  height: 18px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.newsPage__filterButton:hover,
.newsPage__filterButton.is-active {
  border-color: #6fb1df;
  background: #eef6fc;
  color: #155d8c;
}

.newsPage__filterButton > b {
  position: static;
  display: inline-flex;
  min-width: 19px;
  height: 19px;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
  border-radius: 999px;
  background: #227ebd;
  color: #fff;
  font-size: 10.5px;
  font-weight: 800;
}

.newsPage__search {
  width: min(290px, 24vw);
  flex: 0 1 290px;
  margin: 0;
  background: #fff;
}

.newsPage__toolbarSpacer {
  flex: 1 1 auto;
}

.newsPage__columns {
  position: relative;
}

.newsPage__columnsButton {
  height: 40px;
  min-height: 40px;
  gap: 7px;
  border-color: #c8d7df;
  background: #fff;
  color: #1f4f63;
}

.newsPage__columnsButton:hover {
  background: #f4fafc;
}

.newsPage__columnsButton svg {
  width: 17px;
  height: 17px;
  flex: 0 0 auto;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.newsPage__columnsButton > span {
  min-width: 22px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  background: #eef2f6;
  color: #667085;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 800;
}

.newsPage__columnsMenu {
  position: absolute;
  top: calc(100% + 7px);
  right: 0;
  z-index: 1300;
  width: 230px;
  padding: 8px;
  border: 1px solid #dbe3ec;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.16);
}

.newsPage__columnsMenu header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 7px 8px;
  color: #334155;
  font-size: 12px;
}

.newsPage__columnsMenu header button {
  padding: 0;
  border: 0;
  background: transparent;
  color: #1a6da3;
  font-size: 12px;
  font-weight: 700;
}

.newsPage__columnsMenu label {
  min-height: 34px;
  margin: 0;
  padding: 0 7px;
  border-radius: 7px;
  display: flex;
  align-items: center;
  gap: 9px;
  color: #334155;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.newsPage__columnsMenu label:hover {
  background: #f8fafc;
}

.newsPage__columnsMenu input {
  width: 15px;
  height: 15px;
  margin: 0;
  accent-color: #227ebd;
}

.newsPage__filters {
  position: fixed;
  z-index: 1200;
  top: 0;
  right: 0;
  bottom: 0;
  left: auto;
  display: flex;
  width: 360px;
  max-width: calc(100vw - 20px);
  flex-direction: column;
  align-items: stretch;
  gap: 0;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  overflow-y: hidden;
  border: 0;
  border-left: 1px solid #d9e2ec;
  border-radius: 0;
  background: #fff;
  box-shadow: -12px 0 34px rgba(15, 23, 42, 0.14);
}

.newsPage__filters > .newsPage__filterBody {
  display: flex;
  min-height: 0;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 14px;
  margin: 0;
  padding: 18px 18px 24px;
  overflow-x: hidden;
  overflow-y: auto;
}

.newsPage__filters > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid #e6ebf1;
  color: #101828;
}

.newsPage__filters > header button {
  width: 30px;
  height: 30px;
  padding: 0;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #667085;
  font-size: 22px;
}

.newsPage__filters label,
.newsPage__filters input {
  width: 100%;
}

.newsPage__filterDateField {
  width: 100%;
  display: flex;
  align-items: stretch;
  flex-direction: column;
  gap: 6px;
}

.newsPage__filterDateField > span {
  color: #475569;
  font-size: 12px;
  font-weight: 700;
  text-align: left;
}

.newsPage__dateRange {
  width: 100%;
}

.newsPage__filters:has(.sit-dp__pop) {
  z-index: 20000;
}

.newsPage__dateRange .sit-dp__pop {
  z-index: 20001;
  position: fixed;
  top: 50%;
  right: auto;
  bottom: auto;
  left: 50%;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 32px);
  transform: translate(-50%, -50%);
  overflow: hidden;
  overscroll-behavior: contain;
  align-items: stretch;
  animation: none;
}

.newsPage__dateRange .sit-dp__pop > div:last-child {
  min-width: 0;
  min-height: 0;
  max-height: calc(100vh - 32px);
  display: flex;
  flex-direction: column;
}

.newsPage__dateRange .sit-dp__pop > div:last-child > div:first-child {
  min-height: 0;
  overflow: auto;
  overscroll-behavior: contain;
}

.newsPage__dateRange .sit-dp__pop > div:last-child > div:last-child {
  flex: 0 0 auto;
  padding: 0 14px 14px !important;
  border-top: 1px solid #e2e8f0;
  background: #fff;
  box-shadow: 0 -8px 16px rgba(15, 23, 42, 0.08);
}

.newsPage__dateRange .sit-cal__foot {
  position: static;
  margin: 0;
  padding-top: 12px;
}

.newsPage__filterActions {
  width: 100%;
  margin: auto 0 0 !important;
  padding-top: 14px;
  border-top: 1px solid #e6ebf1;
  display: flex;
  align-items: center;
  gap: 6px;
}

.newsPage__filterActions .newsBtn--primary {
  margin-left: auto;
}

.newsBtn--text {
  padding: 0 8px;
  border-color: transparent;
  background: transparent;
  color: #1a6da3;
}

.newsPage__tableCard {
  overflow: visible;
  margin-top: 0;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);
}

.newsPage__tableScroll {
  border-radius: 0 0 12px 12px;
}

@media (max-width: 760px) {
  .newsPage {
    padding-bottom: 24px;
  }

  .newsPage__header {
    width: 100vw;
    height: auto;
    min-height: 70px;
    gap: 12px;
    margin: -16px 0 14px -16px;
    padding: 12px 16px;
  }

  .newsPage__header .newsPage__title {
    overflow: hidden;
    font-size: 20px;
    text-overflow: ellipsis;
  }

  .newsPage__toolbar {
    align-items: stretch;
    padding: 12px;
  }

  .newsPage__search {
    width: 100%;
    flex-basis: 40px;
  }

  .newsPage__filters {
    top: 66px;
    width: min(360px, 100%);
    max-width: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminView/Communications/News/NewsList.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;AACA;EACE,YAAY;EACZ,OAAO;EACP,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;EACV,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE;IACE,YAAY;EACd;EACA;;IAEE,oBAAoB;IACpB,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;AACF;;AAEA,gEAAgE;AAChE;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,8BAA8B;EAC9B,oBAAoB;EACpB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,0BAA0B;EAC1B,sBAAsB;EACtB,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sDAAsD;EACtD,4BAA4B;EAC5B,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,SAAS;EACT,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;;EAEE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,QAAQ;EACR,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,MAAM;EACN,QAAQ;EACR,SAAS;EACT,UAAU;EACV,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,sBAAsB;EACtB,oBAAoB;EACpB,MAAM;EACN,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,SAAS;EACT,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,6BAA6B;EAC7B,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;EAChB,4BAA4B;EAC5B,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,6BAA6B;EAC7B,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;IACpB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,uBAAuB;IACvB,eAAe;EACjB;AACF","sourcesContent":[".newsPage {\n  max-width: 1180px;\n  margin: 24px 0;\n  color: #334155;\n}\n.newsPage__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 20px;\n  margin-bottom: 18px;\n}\n.newsPage__header h1 {\n  margin: 0;\n  color: #142033;\n  font-size: 24px;\n  font-weight: 800;\n}\n.newsPage__header p {\n  margin: 4px 0 0;\n  color: #69778a;\n  font-size: 14px;\n}\n.newsBtn {\n  display: inline-flex;\n  min-height: 40px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 15px;\n  border: 1px solid #cbd5e1;\n  border-radius: 9px;\n  background: #fff;\n  color: #334155;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.newsBtn--primary {\n  border-color: #227ebd;\n  background: #227ebd;\n  color: #fff;\n}\n.newsBtn--ghost.is-active {\n  border-color: #227ebd;\n  background: #eef7fd;\n  color: #155d8c;\n}\n.newsBtn--danger {\n  border-color: #c9364b;\n  background: #c9364b;\n  color: #fff;\n}\n.newsBtn--dangerGhost {\n  border-color: #efb4bd;\n  background: #fff5f6;\n  color: #a7283b;\n}\n.newsPage__toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  border: 1px solid #dbe3ec;\n  border-radius: 12px;\n  background: #fff;\n}\n.newsPage__toolbarTitle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-right: auto;\n}\n.newsPage__toolbarTitle strong {\n  color: #142033;\n  font-size: 15px;\n}\n.newsPage__toolbarTitle span {\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: #eef2f6;\n  color: #69778a;\n  font-size: 11px;\n  font-weight: 700;\n}\n.newsPage__search {\n  display: flex;\n  width: 290px;\n  height: 40px;\n  align-items: center;\n  gap: 8px;\n  padding: 0 11px;\n  border: 1px solid #cbd5e1;\n  border-radius: 9px;\n}\n.newsPage__search:focus-within {\n  border-color: #368fca;\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.11);\n}\n.newsPage__search input {\n  min-width: 0;\n  flex: 1;\n  border: 0;\n  outline: 0;\n  font: inherit;\n  font-size: 13px;\n}\n.newsPage__search > svg {\n  width: 18px;\n  height: 18px;\n  flex: 0 0 18px;\n  fill: none;\n  stroke: #667085;\n  stroke-width: 2;\n  stroke-linecap: round;\n}\n.newsPage__search button {\n  border: 0;\n  background: none;\n  color: #69778a;\n  font-size: 18px;\n}\n.newsPage__filters {\n  display: flex;\n  align-items: flex-end;\n  gap: 12px;\n  margin-top: 10px;\n  padding: 14px;\n  border: 1px solid #dbe3ec;\n  border-radius: 12px;\n  background: #f8fafc;\n}\n.newsPage__filters label {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 700;\n}\n.newsPage__filters input {\n  height: 40px;\n  padding: 0 10px;\n  border: 1px solid #cbd5e1;\n  border-radius: 9px;\n  background: #fff;\n  color: #142033;\n}\n.newsPage__filters > div {\n  display: flex;\n  gap: 8px;\n  margin-left: auto;\n}\n.newsPage__selection {\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n  padding: 10px 13px;\n  border: 1px solid #b9d9ee;\n  border-radius: 10px;\n  background: #eef7fd;\n  color: #155d8c;\n  font-size: 13px;\n  font-weight: 700;\n}\n.newsPage__selection > div {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: auto;\n}\n.newsPage__clear {\n  border: 0;\n  background: none;\n  color: #526174;\n  font-size: 12px;\n  text-decoration: underline;\n}\n.newsPage__tableCard {\n  overflow: hidden;\n  margin-top: 14px;\n  border: 1px solid #dbe3ec;\n  border-radius: 12px;\n  background: #fff;\n}\n.newsPage__tableScroll {\n  overflow-x: auto;\n}\n.newsPage__table {\n  width: 100%;\n  min-width: 760px;\n  border-collapse: collapse;\n}\n.newsPage__table th {\n  height: 44px;\n  padding: 0 14px;\n  border-bottom: 1px solid #dbe3ec;\n  background: #f8fafc;\n  color: #69778a;\n  font-size: 11px;\n  font-weight: 750;\n  letter-spacing: 0.045em;\n  text-align: left;\n  text-transform: uppercase;\n}\n.newsPage__table th button {\n  border: 0;\n  background: none;\n  color: inherit;\n  font: inherit;\n  letter-spacing: inherit;\n  text-transform: inherit;\n}\n.newsPage__table td {\n  height: 68px;\n  padding: 8px 14px;\n  border-bottom: 1px solid #e8edf2;\n  font-size: 13px;\n}\n.newsPage__table tbody tr {\n  cursor: pointer;\n}\n.newsPage__table tbody tr:hover,\n.newsPage__table tbody tr.is-selected {\n  background: #f4f9fc;\n}\n.newsPage__check {\n  width: 46px;\n  text-align: center !important;\n}\n.newsPage__check input {\n  width: 16px;\n  height: 16px;\n  accent-color: #227ebd;\n}\n.newsPage__newsCell {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.newsPage__newsCell img,\n.newsPage__placeholder {\n  width: 48px;\n  height: 42px;\n  flex: 0 0 48px;\n  border-radius: 8px;\n  object-fit: cover;\n}\n.newsPage__placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #e6f2fa;\n  color: #227ebd;\n  font-weight: 800;\n}\n.newsPage__newsCell div {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 3px;\n}\n.newsPage__newsCell strong {\n  color: #142033;\n  font-size: 13px;\n}\n.newsPage__newsCell small {\n  max-width: 520px;\n  overflow: hidden;\n  color: #69778a;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.newsPage__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 9px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 750;\n}\n.newsPage__status i {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: currentColor;\n}\n.newsPage__status.is-published {\n  background: #eaf8f0;\n  color: #237648;\n}\n.newsPage__status.is-scheduled {\n  background: #eef4ff;\n  color: #365f9d;\n}\n.newsPage__empty {\n  padding: 32px 14px !important;\n  color: #69778a;\n  text-align: center;\n}\n.newsPage__pagination {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 6px;\n  margin-top: 14px;\n}\n.newsPage__pagination > span {\n  margin-right: auto;\n  color: #69778a;\n  font-size: 12px;\n}\n.newsPage__pagination button {\n  min-width: 36px;\n  height: 36px;\n  padding: 0 10px;\n  border: 1px solid #d3dce6;\n  border-radius: 8px;\n  background: #fff;\n  color: #475569;\n  font-size: 12px;\n}\n.newsPage__pagination button.is-active {\n  border-color: #227ebd;\n  background: #227ebd;\n  color: #fff;\n}\n.newsPage__pagination button:disabled {\n  opacity: 0.45;\n}\n.newsPage__pagination i {\n  padding: 0 4px;\n  color: #94a3b8;\n}\n.newsFormModal {\n  max-width: 800px !important;\n}\n.newsDeleteModal {\n  max-width: 480px !important;\n}\n.newsDelete {\n  padding: 4px 2px;\n}\n.newsDelete__icon {\n  display: flex;\n  width: 44px;\n  height: 44px;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 14px;\n  border-radius: 50%;\n  background: #fff0f2;\n  color: #bd2f43;\n  font-size: 22px;\n  font-weight: 800;\n}\n.newsDelete p {\n  margin: 0;\n  color: #475569;\n  font-size: 14px;\n  line-height: 1.55;\n}\n.newsDelete__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 9px;\n  margin-top: 24px;\n}\n@media (max-width: 760px) {\n  .newsPage {\n    margin: 16px;\n  }\n  .newsPage__header,\n  .newsPage__toolbar {\n    align-items: stretch;\n    flex-direction: column;\n  }\n  .newsPage__search {\n    width: auto;\n  }\n  .newsPage__filters {\n    align-items: stretch;\n    flex-direction: column;\n  }\n  .newsPage__filters > div {\n    margin-left: 0;\n  }\n  .newsPage__pagination > span {\n    display: none;\n  }\n}\n\n/* Modern list layout shared with People and General messages. */\n.newsPage {\n  position: relative;\n  width: 100%;\n  max-width: none;\n  min-height: calc(100vh - 76px);\n  margin: 0 !important;\n  padding: 0 0 32px;\n  background: var(--surface-page, #f8fafc);\n}\n\n.newsPage__header {\n  display: flex;\n  width: calc(100% + 48px);\n  height: 70px;\n  min-height: 70px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 18px;\n  margin: -20px 0 18px -24px;\n  padding: 0 72px 0 28px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n\n.newsPage__toolbar {\n  min-height: 48px;\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 12px 12px 0 0;\n  background: var(--surface-card, #fff);\n  gap: 8px;\n}\n\n.newsPage__header .newsPage__title {\n  flex: 0 0 auto;\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 22px;\n  font-weight: 800;\n  line-height: 1.1;\n  letter-spacing: -0.015em;\n  white-space: nowrap;\n}\n\n.newsPage__title > span,\n.newsPage__toolbar .newsBtn > b {\n  display: inline-flex;\n  min-width: 22px;\n  height: 22px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 7px;\n  border-radius: 999px;\n  background: #eef2f6;\n  color: #667085;\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.newsPage__title > span {\n  margin-left: 7px;\n  vertical-align: middle;\n}\n\n.newsPage__toolbar .newsBtn,\n.newsPage__search {\n  height: 40px;\n  min-height: 40px;\n}\n\n.newsPage__filterButton {\n  position: relative;\n  display: inline-flex;\n  width: auto;\n  min-width: 40px;\n  height: 40px;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  padding: 0 12px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n  color: #334155;\n  cursor: pointer;\n  font-size: 12.5px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.newsPage__filterButton svg {\n  width: 18px;\n  height: 18px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.newsPage__filterButton:hover,\n.newsPage__filterButton.is-active {\n  border-color: #6fb1df;\n  background: #eef6fc;\n  color: #155d8c;\n}\n\n.newsPage__filterButton > b {\n  position: static;\n  display: inline-flex;\n  min-width: 19px;\n  height: 19px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 5px;\n  border-radius: 999px;\n  background: #227ebd;\n  color: #fff;\n  font-size: 10.5px;\n  font-weight: 800;\n}\n\n.newsPage__search {\n  width: min(290px, 24vw);\n  flex: 0 1 290px;\n  margin: 0;\n  background: #fff;\n}\n\n.newsPage__toolbarSpacer {\n  flex: 1 1 auto;\n}\n\n.newsPage__columns {\n  position: relative;\n}\n\n.newsPage__columnsButton {\n  height: 40px;\n  min-height: 40px;\n  gap: 7px;\n  border-color: #c8d7df;\n  background: #fff;\n  color: #1f4f63;\n}\n\n.newsPage__columnsButton:hover {\n  background: #f4fafc;\n}\n\n.newsPage__columnsButton svg {\n  width: 17px;\n  height: 17px;\n  flex: 0 0 auto;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.9;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.newsPage__columnsButton > span {\n  min-width: 22px;\n  height: 20px;\n  padding: 0 6px;\n  border-radius: 999px;\n  background: #eef2f6;\n  color: #667085;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.newsPage__columnsMenu {\n  position: absolute;\n  top: calc(100% + 7px);\n  right: 0;\n  z-index: 1300;\n  width: 230px;\n  padding: 8px;\n  border: 1px solid #dbe3ec;\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.16);\n}\n\n.newsPage__columnsMenu header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 5px 7px 8px;\n  color: #334155;\n  font-size: 12px;\n}\n\n.newsPage__columnsMenu header button {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #1a6da3;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.newsPage__columnsMenu label {\n  min-height: 34px;\n  margin: 0;\n  padding: 0 7px;\n  border-radius: 7px;\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  color: #334155;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.newsPage__columnsMenu label:hover {\n  background: #f8fafc;\n}\n\n.newsPage__columnsMenu input {\n  width: 15px;\n  height: 15px;\n  margin: 0;\n  accent-color: #227ebd;\n}\n\n.newsPage__filters {\n  position: fixed;\n  z-index: 1200;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: auto;\n  display: flex;\n  width: 360px;\n  max-width: calc(100vw - 20px);\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0;\n  margin: 0;\n  padding: 0;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  border: 0;\n  border-left: 1px solid #d9e2ec;\n  border-radius: 0;\n  background: #fff;\n  box-shadow: -12px 0 34px rgba(15, 23, 42, 0.14);\n}\n\n.newsPage__filters > .newsPage__filterBody {\n  display: flex;\n  min-height: 0;\n  flex: 1 1 auto;\n  flex-direction: column;\n  gap: 14px;\n  margin: 0;\n  padding: 18px 18px 24px;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.newsPage__filters > header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #e6ebf1;\n  color: #101828;\n}\n\n.newsPage__filters > header button {\n  width: 30px;\n  height: 30px;\n  padding: 0;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: #667085;\n  font-size: 22px;\n}\n\n.newsPage__filters label,\n.newsPage__filters input {\n  width: 100%;\n}\n\n.newsPage__filterDateField {\n  width: 100%;\n  display: flex;\n  align-items: stretch;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.newsPage__filterDateField > span {\n  color: #475569;\n  font-size: 12px;\n  font-weight: 700;\n  text-align: left;\n}\n\n.newsPage__dateRange {\n  width: 100%;\n}\n\n.newsPage__filters:has(.sit-dp__pop) {\n  z-index: 20000;\n}\n\n.newsPage__dateRange .sit-dp__pop {\n  z-index: 20001;\n  position: fixed;\n  top: 50%;\n  right: auto;\n  bottom: auto;\n  left: 50%;\n  max-width: calc(100vw - 32px);\n  max-height: calc(100vh - 32px);\n  transform: translate(-50%, -50%);\n  overflow: hidden;\n  overscroll-behavior: contain;\n  align-items: stretch;\n  animation: none;\n}\n\n.newsPage__dateRange .sit-dp__pop > div:last-child {\n  min-width: 0;\n  min-height: 0;\n  max-height: calc(100vh - 32px);\n  display: flex;\n  flex-direction: column;\n}\n\n.newsPage__dateRange .sit-dp__pop > div:last-child > div:first-child {\n  min-height: 0;\n  overflow: auto;\n  overscroll-behavior: contain;\n}\n\n.newsPage__dateRange .sit-dp__pop > div:last-child > div:last-child {\n  flex: 0 0 auto;\n  padding: 0 14px 14px !important;\n  border-top: 1px solid #e2e8f0;\n  background: #fff;\n  box-shadow: 0 -8px 16px rgba(15, 23, 42, 0.08);\n}\n\n.newsPage__dateRange .sit-cal__foot {\n  position: static;\n  margin: 0;\n  padding-top: 12px;\n}\n\n.newsPage__filterActions {\n  width: 100%;\n  margin: auto 0 0 !important;\n  padding-top: 14px;\n  border-top: 1px solid #e6ebf1;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.newsPage__filterActions .newsBtn--primary {\n  margin-left: auto;\n}\n\n.newsBtn--text {\n  padding: 0 8px;\n  border-color: transparent;\n  background: transparent;\n  color: #1a6da3;\n}\n\n.newsPage__tableCard {\n  overflow: visible;\n  margin-top: 0;\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);\n}\n\n.newsPage__tableScroll {\n  border-radius: 0 0 12px 12px;\n}\n\n@media (max-width: 760px) {\n  .newsPage {\n    padding-bottom: 24px;\n  }\n\n  .newsPage__header {\n    width: 100vw;\n    height: auto;\n    min-height: 70px;\n    gap: 12px;\n    margin: -16px 0 14px -16px;\n    padding: 12px 16px;\n  }\n\n  .newsPage__header .newsPage__title {\n    overflow: hidden;\n    font-size: 20px;\n    text-overflow: ellipsis;\n  }\n\n  .newsPage__toolbar {\n    align-items: stretch;\n    padding: 12px;\n  }\n\n  .newsPage__search {\n    width: 100%;\n    flex-basis: 40px;\n  }\n\n  .newsPage__filters {\n    top: 66px;\n    width: min(360px, 100%);\n    max-width: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
